<div class="flex flex-col gap-2 p-3" [hsLayer]="'one'">
  <div class="header">{{ title }}</div>
  <hs-divider></hs-divider>

  <hs-card hsLayer="two">
    <div hsCardTitle>{{ logoCardTitle }}</div>
    <hs-card-body>
      <div class="kfm-print-dialog-columns-container">
        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="logo"
            name="logo"
            (change)="onPropertyChanged($event, 'printClientLogo')"
            [checked]="printSettings.printClientLogo"
          />
          <label for="logo"> {{ printLogoText }}</label>
        </div>
      </div>
    </hs-card-body>
  </hs-card>

  <hs-card hsLayer="two">
    <div hsCardTitle>{{ addressCardTitle }}</div>
    <hs-card-body>
      <div class="kfm-print-dialog-columns-container">
        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="sender"
            name="sender"
            (change)="onPropertyChanged($event, 'printSenderAddress')"
            [checked]="printSettings.printSenderAddress"
          />
          <label for="sender"> {{ printSenderText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="senderLine"
            name="senderLine"
            (change)="onPropertyChanged($event, 'printSenderAddressLine')"
            [checked]="printSettings.printSenderAddressLine"
          />
          <label for="senderLine"> {{ printSenderLineText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="customer"
            name="customer"
            (change)="onPropertyChanged($event, 'printCustomerAddress')"
            [checked]="printSettings.printCustomerAddress"
          />
          <label for="customer"> {{ printCustomerText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="propertyAddress"
            name="propertyAddress"
            [(ngModel)]="printSettings.printPropertyAddress"
          />
          <label for="propertyAddress"> {{ printPropertyAddressText }}</label>
        </div>
      </div>
    </hs-card-body>
  </hs-card>

  <hs-card hsLayer="two">
    <div hsCardTitle>{{ parameterCardTitle }}</div>
    <hs-card-body>
      <div class="kfm-print-dialog-columns-container">
        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="pretext"
            name="pretext"
            (change)="onPropertyChanged($event, 'printPreText')"
            [checked]="printSettings.printPreText"
          />
          <label for="pretext"> {{ printPretextText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="postscript"
            name="postscript"
            (change)="onPropertyChanged($event, 'printPostText')"
            [checked]="printSettings.printPostText"
          />
          <label for="postscript"> {{ printPostscriptText }}</label>
        </div>
      </div>
    </hs-card-body>
  </hs-card>

  <hs-card hsLayer="two">
    <div hsCardTitle>{{ shoppingCartCardTitle }}</div>
    <hs-card-body>
      <div class="kfm-print-dialog-columns-container">
        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="positionNumber"
            name="positionNumber"
            [checked]="
              isColumnSelected(KfmAppShoppingCartColumns.PositionNumber)
            "
            (change)="
              toggleColumn(
                KfmAppShoppingCartColumns.PositionNumber,
                $event.target.checked
              )
            "
          />
          <label for="positionNumber"> {{ printPositionNumberText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="quantity"
            name="quantity"
            [checked]="isColumnSelected(KfmAppShoppingCartColumns.Quantity)"
            (change)="
              toggleColumn(
                KfmAppShoppingCartColumns.Quantity,
                $event.target.checked
              )
            "
          />
          <label for="quantity"> {{ printQuantityText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="unit"
            name="unit"
            [checked]="
              isColumnSelected(KfmAppShoppingCartColumns.UnitOfMeasure)
            "
            (change)="
              toggleColumn(
                KfmAppShoppingCartColumns.UnitOfMeasure,
                $event.target.checked
              )
            "
          />
          <label for="unit"> {{ printUnitText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="articleNumber"
            name="articleNumber"
            [checked]="isColumnSelected(KfmAppShoppingCartColumns.ItemNumber)"
            (change)="
              toggleColumn(
                KfmAppShoppingCartColumns.ItemNumber,
                $event.target.checked
              )
            "
          />
          <label for="articleNumber"> {{ printArticleNumberText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="performance"
            name="performance"
            [checked]="isColumnSelected(KfmAppShoppingCartColumns.Performance)"
            (change)="
              toggleColumn(
                KfmAppShoppingCartColumns.Performance,
                $event.target.checked
              )
            "
          />
          <label for="performance"> {{ printPerformanceText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="vat"
            name="vat"
            [checked]="isColumnSelected(KfmAppShoppingCartColumns.Vat)"
            (change)="
              toggleColumn(KfmAppShoppingCartColumns.Vat, $event.target.checked)
            "
          />
          <label for="vat"> {{ printVatText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="singlePrice"
            name="singlePrice"
            [checked]="isColumnSelected(KfmAppShoppingCartColumns.UnitPrice)"
            (change)="
              toggleColumn(
                KfmAppShoppingCartColumns.UnitPrice,
                $event.target.checked
              )
            "
          />
          <label for="singlePrice"> {{ printSinglePriceText }}</label>
        </div>

        <div class="kfm-print-dialog-column-item">
          <input
            type="checkbox"
            id="totalPrice"
            name="totalPrice"
            [checked]="isColumnSelected(KfmAppShoppingCartColumns.TotalPrice)"
            (change)="
              toggleColumn(
                KfmAppShoppingCartColumns.TotalPrice,
                $event.target.checked
              )
            "
          />
          <label for="totalPrice"> {{ printTotalPriceText }}</label>
        </div>
      </div>
    </hs-card-body>
  </hs-card>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      Abbrechen
    </button>
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="onOkClicked()"
    >
      Ok
    </button>
  </div>
</div>
